
 <iframe *ngIf="showChartCont" [style.height.px]="myInnerHeight"
 (load)="isLoading=false" [class.d-none]="isLoading" [src]="iframeSRC"
 style="width: 100%;"></iframe>
